import {Fragment, useEffect, useRef, useState} from 'react';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {AgreementTemplateService} from '../quan-ly-loai-tai-lieu/tai-lieu-mau/AgreementTemplateService';
import {ToastService, useDataTableBasic} from '@iamsoftware/react-hooks';
import {Service} from '../../service/Service';

export const UploadExcel = ({display, setDisplay, reloadLazyData, agreementId = null}) => {

  const inputSignedFile = useRef(null);
  const [file, setFile] = useState(null);
  const [uploadResult, setUploadResult] = useState([])
  const [displayResult, setDisplayResult] = useState(null)

  const onUploadSignedFile = event => {
    if (event.target?.files?.length === 1) {
      setFile(event.target.files[0]);
    } else {
      ToastService.error('Chưa chọn file Excel')
    }
  }

  const downloadExcel = (agreementId: string) => {
    AgreementTemplateService.downloadTemplate(agreementId);
  }

  useEffect(() => {
    if (!display) {
      setFile(null);
      if (inputSignedFile.current) {
        inputSignedFile.current.value = '';
      }
    }
  }, [display]);

  const {render: renderDataTableItem} = useDataTableBasic({
    tableHeader: `Chi tiết kết quả`,
    dataKey: 'rowNum',
    columns: [
      {field: 'rowNum', header: 'Dòng dữ liệu', width: 110, dataType: 'number'},
      {field: 'agreementNo', header: 'Mã tài liệu', width: 140},
      {field: 'agreementName', header: 'Tên tài liệu', width: 200},
      {
        field: 'success', header: 'Kết quả', width: 100, dataType: 'custom', customCell(rowData: any): any {
          let access;
          if (rowData.success === 'Y') {
            access = <p>
              <i className="true-icon pi pi-check-circle mr-1"></i>
              <span>Thành công</span>
            </p>
          } else {
            access = <p>
              <i className="false-icon pi pi-times-circle mr-1"></i>
              <span>Thất bại</span>
            </p>
          }
          return <div>
            {access}
          </div>

        }
      },
      {field: 'error', header: 'Mô tả lỗi', width: 350}
    ],
    items: uploadResult
  });

  const onSubmit = () => {
    if (!file) {
      ToastService.error('Vui lòng chọn file Excel');
      return;
    }
    const formData: any = {contentFile: file};
    if (agreementId) {
      formData.agreementConfigureEnumId = agreementId;
    }
    AgreementTemplateService.uploadExcel(agreementId, Service.toFormData(formData)).then(data => {
      setUploadResult(data.resultList || []);
      setDisplayResult(Date.now());
      reloadLazyData();
    }).catch(error => {
      ToastService.error(error?.message || 'Có lỗi xảy ra khi upload file Excel');
    });
    if (inputSignedFile.current) {
      inputSignedFile.current.value = '';
    }
  }

  const close = () => {
    setDisplay(false)
    setDisplayResult(false)
  }

  const footer = (
    <div className="flex justify-content-end">
      <Button label="Tải file excel mẫu" icon="pi pi-download" className="p-button-outlined p-button-help p-button-sm mr-2" type="button" onClick={() => downloadExcel(agreementId)}/>
      <Button label="Tải lên" icon="pi pi-upload" className="p-button-outlined p-button-success p-button-sm mr-2" type="button" onClick={onSubmit}/>
      <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplay(false)}/>
    </div>
  );
  const resultFooter = (
    <div className="flex justify-content-end">
      <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplayResult(null)}/>
    </div>
  );

  return (
    <Fragment>
      <Dialog header={'Upload file Excel tài liệu'} draggable={false} footer={footer} visible={!!display} style={{width: '40rem', height: '15rem',}} position="top" onHide={() => setDisplay(false)}>
        <div className="grid col-12">
          <div className="col-12">
            <div>Chọn file Excel<span style={{color: 'red'}}>*</span></div>
            <input className="mt-2 md:col-12" ref={inputSignedFile} type="file" accept='.xlsx' onChange={onUploadSignedFile}/>
          </div>
        </div>
      </Dialog>
      <Dialog header={'Kết quả upload Excel tài liệu'} footer={resultFooter} visible={!!displayResult} style={{width: '80rem',}} position="top" onHide={() => close()}>
        {renderDataTableItem()}
      </Dialog>
    </Fragment>
  );
}

